// import axios from 'axios'
import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { formSubmitClear, formComplete } from 'actions/forms'

export const PARTNER_HIERARCHY_GETING_PARTNER_HIERARCHY = 'PARTNER_HIERARCHY_GETING_PARTNER_HIERARCHY'
export const PARTNER_HIERARCHY_RECEIVED_PARTNER_HIERARCHY = 'PARTNER_HIERARCHY_RECEIVED_PARTNER_HIERARCHY'
export const PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_START = 'PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_START'
export const PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_COMPLETE = 'PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_COMPLETE'

const getPartnerHierarchy = () => ({
  type: PARTNER_HIERARCHY_GETING_PARTNER_HIERARCHY,
})

const receivePartnerHierarchy = partner => ({
  type: PARTNER_HIERARCHY_RECEIVED_PARTNER_HIERARCHY,
  partner,
})

const savePartnerHierarchyStart = () => ({
  type: PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_START,
})

const savePartnerHierarchyComplete = () => ({
  type: PARTNER_HIERARCHY_SAVE_PARTNER_HIERARCHY_COMPLETE,
})

export function loadSelectedPartnerHierarchy(currentUserId, selectedPartnerId) {
  return (dispatch) => {
    dispatch(getPartnerHierarchy())
    agent.PartnerHierarchy.getPartnerHierarchy(currentUserId, selectedPartnerId).then((response) => {
      dispatch(receivePartnerHierarchy(response))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <loadSelectedPartnerHierarchy>: ', description, error)
      }
    })
  }
}

export function editPartnerHierarchy(data, currentUserId, formId) {
  return (dispatch) => {
    dispatch(savePartnerHierarchyStart())
    agent.PartnerHierarchy.editPartnerHierarchy(data, currentUserId).then((response) => {
      dispatch(savePartnerHierarchyComplete())
      dispatch(notify(`Partner hierarchy updated ${response}`))
      dispatch(formComplete(formId))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify('Problem saving Partner hierarchy, please try again.'))
        dispatch(formSubmitClear(formId))
        // console.warn('Err <editPartnerHierarchy>: ', description, error)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/partnerHierarchyForm.js